import { InputFileField, InputLabel, InputWrapper } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { FieldArray, useFormikContext } from 'formik';
import type { FC } from 'react';
import { useState } from 'react';
import { useTheme } from '@emotion/react';
import { CiSquarePlus } from 'react-icons/ci';
import * as Styled from '../styled';
import type { MtBreederOnboardingFormValues, MtBreederOnboardingPageProps } from '../types';

export const Step11: FC<Pick<MtBreederOnboardingPageProps, 'log'>> = (props) => {
  const { log } = props;
  const { values } = useFormikContext<MtBreederOnboardingFormValues>();
  const [imagesAmout, setImageAmount] = useState(values?.images?.length ?? 3);
  const { translate } = useTranslation();
  const theme = useTheme();
  return (
    <>
      <Styled.BlueInfoBox full>{translate('common.inputs.profilePicture.warn')}</Styled.BlueInfoBox>
      <Styled.FlexContainer2>
        <InputWrapper split last>
          <InputLabel required>{translate('common.inputs.profilePicture.label')}</InputLabel>
          <Styled.ProfilePictureWrapper>
            <InputFileField
              name="profileImage"
              accept="image/*, .heic, .heif"
              imageCropperProps={{
                maxCompressedSize: 8 * 1000000,
              }}
              log={log}
            />
          </Styled.ProfilePictureWrapper>
        </InputWrapper>

        <InputWrapper>
          <InputLabel required requiredColor="red">
            {translate('common.inputs.breederPictures.label')}
          </InputLabel>
          <FieldArray name="images">
            {() => (
              <Styled.ImageContainer>
                {new Array(imagesAmout).fill(undefined).map((_, index) => (
                  <Styled.ImageWrapper key={index}>
                    <InputFileField
                      name={`images[${index}]`}
                      accept="image/*, .heic, .heif"
                      required
                      imageCropperProps={{
                        maxCompressedSize: 8 * 1000000,
                      }}
                      log={log}
                    />
                  </Styled.ImageWrapper>
                ))}
                {imagesAmout < 9 && (
                  <Styled.AddImage
                    onClick={() => {
                      if (imagesAmout < 9) {
                        setImageAmount(imagesAmout + 1);
                      }
                    }}
                  >
                    <CiSquarePlus size={50} color={theme.color.dark.default} />
                  </Styled.AddImage>
                )}
              </Styled.ImageContainer>
            )}
          </FieldArray>
        </InputWrapper>
      </Styled.FlexContainer2>
    </>
  );
};
